export const ALERTS_URL = 'alerts'
export const ALERT_DETAIL_PARAM = 'alertId'
export const ALERTS_DETAIL_PATH = `${ALERTS_URL}/:${ALERT_DETAIL_PARAM}`

export const ALERTS_TRANSACTION_PATH = `/project/:id/${ALERTS_URL}`
export const ALERTS_DETAIL_TRANSACTION_PATH = `${ALERTS_TRANSACTION_PATH}/:${ALERT_DETAIL_PARAM}`

export const buildProjectAlertsPath = (projectId: string): string =>
  `/project/${projectId}/${ALERTS_URL}`

export const buildProjectAlertPath = (
  projectId: string,
  alertId: number | string,
): string => `${buildProjectAlertsPath(projectId)}/${alertId}`
